export default __webpack_public_path__ + "static/media/IBimagesSwinglegrecovery1.89792ae2.png";